/**
 * Per-request UMK-proof header construction (parent spec §8).
 *
 * The unlock session holds the in-memory UMK + the account's userId bytes. For a
 * `jwt+umk-proof` request the client MACs `method:path:nonce:sha256(body)` with
 * `HKDF(UMK,userId)` and sends the result alongside the nonce. The server holds
 * the same HKDF output (uploaded at enrolment) and re-verifies — proving the
 * caller has unlocked, without the server ever seeing the UMK.
 */
import { computeUmkProof } from '@heivol-locker/crypto';
import { UMK_NONCE_HEADER, UMK_PROOF_HEADER } from '@heivol-locker/shared-types';
import { sha256, toBase64, utf8 } from './base64.js';
export async function umkProofHeaders(args) {
    const bodyHash = await sha256(utf8(args.bodyText));
    const mac = await computeUmkProof({
        umk: args.session.umk,
        userId: args.session.userIdBytes,
        method: args.method,
        path: args.path,
        nonceHeader: args.nonce,
        bodyHash,
    });
    return {
        [UMK_NONCE_HEADER]: args.nonce,
        [UMK_PROOF_HEADER]: toBase64(mac),
    };
}
//# sourceMappingURL=umk-proof.js.map